import React from 'react';
import { Form } from '../../shared/Form/Form';

const Contact = () => {
    return (
        <div className="z-[100]">
               {/* The button to open modal */}
                

                {/* Put this part before </body> tag */}
                <input type="checkbox" id="my-modal-3" className="modal-toggle" />
                <div className="modal">
                <div className="modal-box relative">
                    <label htmlFor="my-modal-3" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                    <Form></Form>
                </div>
                </div>
    
        </div>
    );
};

export default Contact;